import styled from "styled-components";
import { theme } from "../../styles/theme";
import { pagePaddingX } from "../../styles/layout";

export const NotFoundSection = styled("section")`
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  ${pagePaddingX}
  padding-top: 4rem;
  padding-bottom: 4rem;
  background: ${theme.colors.background};
`;

export const NotFoundInner = styled("div")`
  text-align: center;
  max-width: 480px;
`;

export const NotFoundCode = styled("p")`
  font-family: ${theme.fonts.heading};
  font-size: 5rem;
  font-weight: 700;
  color: ${theme.colors.tanDark};
  line-height: 1;
  margin-bottom: 1rem;
`;

export const NotFoundTitle = styled("h1")`
  margin-bottom: 1rem;
`;

export const NotFoundText = styled("p")`
  color: ${theme.colors.textLight};
  margin-bottom: 2rem;
`;

export const Actions = styled("div")`
  display: flex;
  justify-content: center;

  a {
    text-decoration: none;
  }

  button {
    margin-top: 0;
  }
`;
